export const SUPPORTED_AUDIO_FORMATS = ['audio/mpeg', 'audio/wav'];

export const fileTypeValidate = (file: File, extensions: string[]) =>
	extensions.includes(file.type);

export const audioFileValidate = (file: File) =>
	SUPPORTED_AUDIO_FORMATS.includes(file?.type);
